import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
  FormGroup,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import moment from "moment";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import fmtFecha from "../../../../utils/fmtFecha";

function AbonosCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_ABONOS = import.meta.env.VITE_URL_ABONOS;
  const URL_SURTIDOS = import.meta.env.VITE_URL_SURTIDOS;
  const URL_BANCOS = import.meta.env.VITE_URL_BANCOS;
  const URL_NOTAS_CARGO = import.meta.env.VITE_URL_NOTAS_CARGO;
  const URL_WHATSAPP = import.meta.env.VITE_URL_WHATSAPP;
  const URL_ESTADO_CUENTA = import.meta.env.VITE_URL_ESTADO_CUENTA;

  let date = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let hoy = moment(date).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [text, setText] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedClienteNombre, setSelectedClienteNombre] = useState("");
  const [selectedClienteTelefono, setSelectedClienteTelefono] = useState("");
  const [alertasCliente, setAlertasCliente] = useState("No");
  const [fecha, setFecha] = useState(hoy);

  const [selectedBanco, setSelectedBanco] = useState("");
  const [bancos, setBancos] = useState([]);
  const [formaPago, setFormaPago] = useState("");

  const [value, setValue] = useState(null);
  const [validaBoton, setValidaBoton] = useState(true);
  const [concepto, setConcepto] = useState("");
  const [total, setTotal] = useState(0);
  const [importeAplicar, setImporteAplicar] = useState(0);
  const [saldoAplicar, setSaldoAplicar] = useState(0);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [inputFields, setInputFields] = useState([]);
  const [inputFieldsNC, setInputFieldsNC] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useMemo(() => {
    axios
      .get(`${URL_CLIENTES}Activos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    if (selectedCliente) {
      axios
        .get(`${URL_SURTIDOS}Cliente/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allCargos = response.data;
          let arrayTabla = allCargos
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.total_general,
                saldo: a.saldo,
                nota: a.idSurtido,
                importe: a.saldo,
                clientes: a.clientes[0]._id,
                colaboradores: a.clientes[0].vendedor[0]._id,
                observaciones: "NA",
                movimiento: "Nota",
                select: false,
              };
            })
            .filter(function (el) {
              return el != null;
            });
          let dataFinal = Object.values(arrayTabla);
          setInputFields(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });

      axios
        .get(`${URL_NOTAS_CARGO}Cliente/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allCargosNC = response.data;
          let arrayTablaNC = allCargosNC
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.importe,
                saldo: a.saldo,
                nota: a.idNotaCargo,
                importe: a.saldo,
                clientes: a.clientes[0]._id,
                colaboradores: a.clientes[0].vendedor[0]._id,
                observaciones: "NA",
                movimiento: "Nota de Cargo",
                select: false,
              };
            })
            .filter(function (el) {
              return el != null;
            });
          let dataFinalNC = Object.values(arrayTablaNC);
          setInputFieldsNC(dataFinalNC);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedCliente]);

  function clear() {
    setInputFields([]);
    setInputFieldsNC([]);
    setImporteAplicar(0);
    setSaldoAplicar(0);
    setCodigoAgrupado(uuidv4());
    setConcepto("");
    setTotal(0);
    setFormaPago("");
    setValidaBoton(true);
    setSelectedCliente("");
    setSelectedClienteNombre("");
    setSelectedClienteTelefono("");
    setSelectedBanco("");
    setFecha(hoy);
    setValue("");
    setModalProgreso(false);
  }

  function refreshClientData() {
    if (selectedCliente) {
      // Refresh Surtidos data
      axios
        .get(`${URL_SURTIDOS}Cliente/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allCargos = response.data;
          let arrayTabla = allCargos
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.total_general,
                saldo: a.saldo,
                nota: a.idSurtido,
                importe: a.saldo,
                clientes: a.clientes[0]._id,
                colaboradores: a.clientes[0].vendedor[0]._id,
                observaciones: "NA",
                movimiento: "Nota",
                select: false,
              };
            })
            .filter(function (el) {
              return el != null;
            });
          let dataFinal = Object.values(arrayTabla);
          setInputFields(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });

      // Refresh Notas Cargo data
      axios
        .get(`${URL_NOTAS_CARGO}Cliente/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allCargosNC = response.data;
          let arrayTablaNC = allCargosNC
            .map((a) => {
              return {
                id: a._id,
                fecha: a.fecha,
                total_general: a.importe,
                saldo: a.saldo,
                nota: a.idNotaCargo,
                importe: a.saldo,
                clientes: a.clientes[0]._id,
                colaboradores: a.clientes[0].vendedor[0]._id,
                observaciones: "NA",
                movimiento: "Nota de Cargo",
                select: false,
              };
            })
            .filter(function (el) {
              return el != null;
            });
          let dataFinalNC = Object.values(arrayTablaNC);
          setInputFieldsNC(dataFinalNC);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  const handleChangeInputImporte = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo || value == null) {
          i[name] = value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputImporteNC = (value, name, id) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        if (value <= i.saldo || value == null) {
          i[name] = value;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "El Pago excede el Saldo",
          });
        }
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let activos = inputFields.filter((e) => e.select == true);
    let TEfe = activos.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let activosNC = inputFieldsNC.filter((e) => e.select == true);
    let TEfeNC = activosNC.map((c) => parseFloat(c.importe));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    setTotal(parseFloat(TENC + TE).toFixed(2));

    setSaldoAplicar((importeAplicar - TE - TENC).toFixed(2));
  }

  function savePago() {
    setValidaBoton(false);
    if (
      value != null &&
      concepto != "" &&
      formaPago != "" &&
      selectedBanco != ""
    ) {
      if (saldoAplicar == 0) {
        Swal.fire({
          title: "Estas seguro?",
          text: "Se registrará el abono",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Enviar!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            toggleProgreso();

            try {
              const itemsSurtidos = inputFields
                .filter((a) => a.select == true && a.importe > 0)
                .map((a) => ({
                  surtidos: a.id,
                  importe: parseFloat(a.importe),
                  colaboradores: a.colaboradores,
                  observaciones: a.observaciones,
                  comisionPagada: "No",
                  editado: "No",
                }));

              const itemsNC = inputFieldsNC
                .filter((a) => a.select == true && a.importe > 0)
                .map((a) => ({
                  notasCargo: a.id,
                  importe: parseFloat(a.importe),
                  colaboradores: a.colaboradores,
                  observaciones: a.observaciones,
                  comisionPagada: "No",
                  editado: "No",
                }));

              const items = [...itemsSurtidos, ...itemsNC];

              await axios.post(
                `${URL_ABONOS}Completa`,
                {
                  fecha,
                  clientes: selectedCliente,
                  formaPago,
                  concepto,
                  bancos: selectedBanco,
                  codigoAgrupado,
                  items,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              );

              if (alertasCliente == "Si") {
                PDFOC();
              }
              Swal.fire("Good job!", "Creado con exito", "success");
              setImporteAplicar(0);
              setSaldoAplicar(0);
              setTotal(0);
              setCodigoAgrupado(uuidv4());
              setValidaBoton(true);
              setModalProgreso(false);
              refreshClientData();
            } catch (error) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
              console.log(error);
              setValidaBoton(true);
              setModalProgreso(false);
            }
          }
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Todavia te queda Saldo por aplicar",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes completar todo el formulario",
      });
    }
  }

  async function PDFOC() {
    await axios
      .get(`${URL_ESTADO_CUENTA}Agrupado/${selectedCliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;

        let SI = allVentas
          .map((c) => {
            if (startDate > c.fecha) {
              return c.cargo - c.abono;
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let TC = SI.reduce((t, total, index) => t + total, 0);

        let saldoParcial = TC;
        let totalCargosEdoCte = 0;
        let totalAbonosEdoCte = 0;
        let totalSaldoEdoCte = 0;

        const data = allVentas.map((a) => {
          if (startDate <= a.fecha) {
            totalCargosEdoCte = totalCargosEdoCte + a.cargo;
            totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
            totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdoCte;
            saldoParcial = saldoParcial + a.cargo - a.abono;
            const cargos = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.cargo);
            const abonos = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.abono);
            var saldoParcialFormato = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(saldoParcial);
            return [
              a.fecha,
              a.movimiento,
              a.numero,
              cargos,
              abonos,
              saldoParcialFormato,
            ];
          }
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({ compressPdf: true });
        var img = new Image();
        img.src = "Logo-Sistemify-PDF.png";
        doc.addImage(img, "png", 150, 5, 33, 10);
        var img2 = new Image();
        img2.src = "logoInstitucion.png";
        doc.addImage(img2, "png", 155, 15, 25, 25);
        doc.text(`Estado de Cuenta`, 15, 30);
        doc.text(`Cliente ${selectedClienteNombre}`, 15, 37);
        doc.setFontSize(12);
        doc.text(`Se muestran los movimientos de los ultimos 30 dias`, 15, 44);

        const columnTitles = [
          ["Fecha", "Movimiento", "Numero", "Cargos", "Abonos", "Saldo"],
        ];

        const additionalRow = [
          {
            content: `Saldo Anterior ${new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(TC)}`,
            colSpan: 6,
            styles: { halign: "center" },
          },
        ];

        doc.autoTable({
          head: columnTitles,
          startY: 48,
          // headStyles: { fillColor: [211, 211, 211], textColor: [0, 0, 0], fontSize: 12 },
        });

        doc.autoTable({
          head: [additionalRow],
          body: [],
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontSize: 14,
          },
        });

        doc.autoTable({
          body: dataPDFLimpia,
          // startY: doc.autoTable.previous.finalY + 10,
          foot: [
            [
              "",
              "",
              // "",
              "",
              {
                content: "Saldo Anterior",
                colSpan: 2,
                styles: { halign: "left" },
              },
              // "Saldo Anterior",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(TC),
            ],
            [
              "",
              "",
              // "",
              "",
              {
                content: "Cargos del Periodo",
                colSpan: 2,
                styles: { halign: "left" },
              },
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalCargosEdoCte),
            ],
            [
              "",
              "",
              // "",
              "",
              {
                content: "Abonos del Periodo",
                colSpan: 2,
                styles: { halign: "left" },
              },
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(totalAbonosEdoCte),
            ],
            [
              "",
              "",
              // "",
              "",
              {
                content: "Saldo Actual",
                colSpan: 2,
                styles: { halign: "left" },
              },
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
              }).format(saldoParcial),
            ],
          ],
          showFoot: "lastPage",
        });

        var att = doc.output("arraybuffer");

        let params = new URLSearchParams({
          number: selectedClienteTelefono,
          message: `Hola ${selectedClienteNombre}, Aquí te enviamos tu estado de cuenta actualizado`,
          fileName: `EstadoCuenta.pdf`,
          mimetype: "application/pdf",
        });
        axios.post(`${URL_WHATSAPP}SendPDFFront?${params.toString()}`, att, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/octet-stream",
          },
        });

        //
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  const handleChangeInputNC = (id, event) => {
    const newInputFieldsNC = inputFieldsNC.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFieldsNC(newInputFieldsNC);
  };

  const options = clientes.map((option) => {
    const junta = option.nombre_comercial + " " + option.codigo;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  function IA(e) {
    setImporteAplicar(e);

    let activos = inputFields.filter((e) => e.select == true);
    let TEfe = activos.map((c) => parseFloat(c.importe));
    let TE = TEfe.reduce((t, total, index) => t + total, 0);

    let activosNC = inputFieldsNC.filter((e) => e.select == true);
    let TEfeNC = activosNC.map((c) => parseFloat(c.importe));
    let TENC = TEfeNC.reduce((t, total, index) => t + total, 0);

    let TF = parseFloat(TE).toFixed(2);
    let TFNC = parseFloat(TENC).toFixed(2);

    setTotal(parseFloat(TF + TFNC).toFixed(2));

    setSaldoAplicar((e - TF - TENC).toFixed(2));
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.abonosCreate ? (
        <div className="card container col-sm-11">
          <h3 align="center">Captura un Pago</h3>
          <Form>
            <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Fecha</Label>
                  <Input
                    type="date"
                    value={fecha}
                    required
                    onChange={(e) => {
                      setFecha(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Autocomplete
                    size="small"
                    value={value}
                    onChange={(event, selectedCliente) => {
                      if (selectedCliente) {
                        setValue(selectedCliente);
                        setSelectedCliente(selectedCliente._id);
                        setSelectedClienteNombre(
                          selectedCliente.nombre_comercial
                        );
                        setSelectedClienteTelefono(selectedCliente.telefono);
                        setAlertasCliente(selectedCliente.alertas);
                      }
                    }}
                    options={options.sort(
                      (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                    )}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option?.junta || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Selecciona"
                        variant="outlined"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        {option.codigo} {option.nombre_comercial}
                      </li>
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Concepto</Label>
                  <Input
                    type="select"
                    value={concepto}
                    onChange={(e) => {
                      setConcepto(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Concepto</option>
                    <option value="Abono">Abono</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>

                <Col md={2}>
                  <Label className="mr-sm-2">Forma de Pago</Label>
                  <Input
                    type="select"
                    value={formaPago}
                    onChange={(e) => {
                      setFormaPago(e.target.value);
                    }}
                  >
                    <option value="">Selecciona una Forma de Pago</option>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Transfer">Transfer</option>
                    <option value="TDC">TDC</option>
                    <option value="Bonificacion">Bonificacion</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Banco</Label>
                  <Input
                    type="select"
                    value={selectedBanco}
                    onChange={(e) => {
                      setSelectedBanco(e.target.value);
                    }}
                  >
                    <option value="">Selecciona un Banco</option>
                    {bancos
                      .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.banco} {a.cuenta}
                          </option>
                        );
                      })}
                  </Input>
                </Col>

                <Col md={1}>
                  <h4 align="right">
                    Total Pago{"  "}
                    <Badge
                      id="Total"
                      color="danger"
                      className="BadgeSize badge-pill"
                    >
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 2,
                      }).format(total)}
                    </Badge>
                  </h4>
                </Col>
              </Row>
              <br />
              <Row>
                <Col md={2}>
                  <Label>Importe Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={importeAplicar}
                    className={`form-control`}
                    onValueChange={(value, name) => IA(value)}
                  />
                </Col>
                <Col md={2}>
                  <Label>Saldo Por Aplicar</Label>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    value={saldoAplicar}
                    className={`form-control`}
                    disabled
                  />
                </Col>
              </Row>
              <br />
              <Row>
                {/* Tabla Cargos */}
                <br />
                <br />
                <Table striped borderless>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Fecha</th>
                      <th>Movimiento</th>
                      <th>Nota</th>
                      <th>Total</th>
                      <th>Abonos</th>
                      <th>Saldo</th>
                      <th>Importe</th>
                      <th>Observaciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((a) => (
                      // <div key={a.id}>
                      <tr>
                        <th>
                          <Input
                            type="checkbox"
                            onChange={(e) => {
                              let checked = e.target.checked;
                              setInputFields(
                                inputFields.map((data) => {
                                  if (a.id == data.id) {
                                    data.select = checked;
                                  }
                                  return data;
                                })
                              );
                              ActualizaTotales();
                            }}
                            checked={a.select}
                          />
                        </th>
                        <td>{fmtFecha(a.fecha)}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_general)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_general - a.saldo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.saldo)}
                        </td>
                        <td>
                          {a.select ? (
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              onValueChange={(value, name) =>
                                handleChangeInputImporte(value, name, a.id)
                              }
                            />
                          ) : (
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              disabled
                            />
                          )}
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInput(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}

                    {inputFieldsNC.map((a) => (
                      // <div key={a.id}>
                      <tr>
                        <th>
                          <Input
                            type="checkbox"
                            onChange={(e) => {
                              let checked = e.target.checked;
                              setInputFieldsNC(
                                inputFieldsNC.map((data) => {
                                  if (a.id == data.id) {
                                    data.select = checked;
                                  }
                                  return data;
                                })
                              );

                              ActualizaTotales();
                            }}
                            checked={a.select}
                          />
                        </th>
                        <td>{fmtFecha(a.fecha)}</td>
                        <td>{a.movimiento}</td>
                        <td>{a.nota}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_general)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.total_general - a.saldo)}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.saldo)}
                        </td>
                        <td>
                          {a.select ? (
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              onValueChange={(value, name) =>
                                handleChangeInputImporteNC(value, name, a.id)
                              }
                            />
                          ) : (
                            <CurrencyInput
                              intlConfig={{ locale: "en-US", currency: "USD" }}
                              prefix="$"
                              name="importe"
                              defaultValue={0}
                              decimalsLimit={2}
                              value={a.importe}
                              className={`form-control`}
                              disabled
                            />
                          )}
                        </td>
                        <td>
                          <Input
                            type="text"
                            name="observaciones"
                            value={a.observaciones}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputNC(a.id, e);
                            }}
                          />
                        </td>
                      </tr>
                      // </div>
                    ))}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        Total
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(total)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                  <br />
                </Table>

                {/* Termina tabla cargos */}
              </Row>
            </FormGroup>
            <br />
            <Row>
              <Button className="btn btn-success" onClick={savePago}>
                {" "}
                Registrar
              </Button>

              <Button
                className="btn btn-warning mx-2"
                onClick={clear}
                title="Limpiar formulario para empezar con un nuevo cliente"
              >
                Limpiar Formulario
              </Button>

              <Button
                href="/ListadoAbonos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Row>
          </Form>
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default AbonosCreate;
